// @flow
import client from '../../client'
import { config } from '../../config'
import buildPrebookPriceUpdate from './builders/prebookPriceUpdate'
import buildOndemandPriceUpdate from './builders/ondemandPriceUpdate'
import { filterPriceQuery } from './utils'

// Types
import type { PriceUpdate } from '../../models/price'

export type Options = {
  ondemand?: boolean,
  search_id: string,
  result_id: string,
  copuon_code?: ?string,
  gratuity_percent?: number,
  commission?: number,
  optional_amenities?: string[],
  currency?: string,
  commission_currency?: string,
  ta_email?: string,
  cc_type?: string,
  ticket_id?: string,
  alternative_time_index?: number,
  return_ticket_id?: string,
  return_alternative_time_index?: number,
}

// API Endpoints
export const PRICE_GET_ENDPOINT = '/pricing/'
export const ONDEMAND_PRICE_GET_ENDPOINT = '/ondemand/pricing/'

/**
 * Returns price information for a trip
 * For more information about data format see:
 * https://api-staging.mozio.com/v2/docs/#!/pricing/Pricing_get_pricing
 * @param {Object} data Price information.
 * @return {Promise|Error} A resolved Promise with the update Price object or Rejected with an Error
 */
export const getPrebookPrice = (data: Options): Promise<PriceUpdate> => {
  const query = filterPriceQuery(data)
  return client
    .post(PRICE_GET_ENDPOINT, { body: query, baseUrl: config.BASE_URL_PRICING })
    .then(buildPrebookPriceUpdate)
}

export const getOndemandPrice = (data: Options): Promise<PriceUpdate> => {
  const query = filterPriceQuery(data)
  return client
    .get(ONDEMAND_PRICE_GET_ENDPOINT, {
      query,
      baseUrl: config.BASE_URL_PRICING,
    })
    .then(buildOndemandPriceUpdate)
}

const getPrice = (data: Options): Promise<PriceUpdate> =>
  data.ondemand ? getOndemandPrice(data) : getPrebookPrice(data)

export default getPrice
